import { sumCharCodeHash } from "./sum-char-code-hash";

/**
 * 30 illumi persona pairs for anonymous guest users.
 *
 * Three visually distinct color packs, interleaved so consecutive indices
 * always draw from a different pack:
 *   Vibrant  — HSL(H, 70%, 60%): saturated, energetic
 *   Pastel   — HSL(H, 45%, 82%): soft, airy
 *   Deep     — HSL(H, 60%, 42%): rich, bold
 *
 * Each pack covers 10 hues spaced 36° apart (offset between packs so
 * all 30 hues are unique). Interleaved order: V, P, D, V, P, D, …
 */
export const GUEST_PERSONAS = [
	{ name: "illumi Poppy", color: "#E05252" }, // vibrant red
	{ name: "illumi Peach", color: "#E6C5BC" }, // pastel peach
	{ name: "illumi Fox", color: "#AB5E2B" }, // deep orange-brown
	{ name: "illumi Marigold", color: "#E0A752" }, // vibrant orange
	{ name: "illumi Chamomile", color: "#E6DEBC" }, // pastel yellow
	{ name: "illumi Olive", color: "#ABAB2B" }, // deep olive
	{ name: "illumi Kiwi", color: "#C4E052" }, // vibrant lime
	{ name: "illumi Pistachio", color: "#D5E6BC" }, // pastel lime
	{ name: "illumi Gecko", color: "#5EAB2B" }, // deep green
	{ name: "illumi Clover", color: "#6EE052" }, // vibrant green
	{ name: "illumi Fern", color: "#BCE6BC" }, // pastel green
	{ name: "illumi Orca", color: "#2BAB45" }, // deep teal-green
	{ name: "illumi Jade", color: "#52E08B" }, // vibrant seafoam
	{ name: "illumi Seafoam", color: "#BCE6D5" }, // pastel mint
	{ name: "illumi Heron", color: "#2BAB92" }, // deep teal
	{ name: "illumi Lagoon", color: "#52E0E0" }, // vibrant cyan
	{ name: "illumi Mist", color: "#BCDEE6" }, // pastel sky
	{ name: "illumi Manta", color: "#2B78AB" }, // deep blue
	{ name: "illumi Bluebell", color: "#528BE0" }, // vibrant blue
	{ name: "illumi Periwinkle", color: "#BCC5E6" }, // pastel periwinkle
	{ name: "illumi Indigo", color: "#2B2BAB" }, // deep indigo
	{ name: "illumi Iris", color: "#6E52E0" }, // vibrant indigo
	{ name: "illumi Lilac", color: "#CDBCE6" }, // pastel lavender
	{ name: "illumi Wisteria", color: "#782BAB" }, // deep purple
	{ name: "illumi Orchid", color: "#C452E0" }, // vibrant purple
	{ name: "illumi Blossom", color: "#E6BCE6" }, // pastel orchid
	{ name: "illumi Dahlia", color: "#AB2B92" }, // deep magenta
	{ name: "illumi Flamingo", color: "#E052A7" }, // vibrant pink
	{ name: "illumi Petal", color: "#E6BCCD" }, // pastel rose
	{ name: "illumi Garnet", color: "#AB2B45" }, // deep crimson
] as const;

export type GuestPersona = (typeof GUEST_PERSONAS)[number];

/** Deterministically maps a guest session ID to a persona. */
export function getGuestPersona(sessionId: string): GuestPersona {
	const index = sumCharCodeHash(sessionId) % GUEST_PERSONAS.length;
	return GUEST_PERSONAS[index];
}

export function getGuestDisplayName(sessionId: string): string {
	return getGuestPersona(sessionId).name;
}
